import React from "react";
import { Box } from "@mui/material";
import { toolbarRowSx } from "../../theme/njimTheme";

interface FilterBarProps {
  children: React.ReactNode;
}

const FilterBar: React.FC<FilterBarProps> = ({ children }) => {
  return (
    <Box
      sx={{
        ...toolbarRowSx,
        mb: 2,
        "& > *": {
          minWidth: { xs: "100%", sm: 180 },
          flex: { xs: "1 1 100%", sm: "0 1 auto" },
        },
      }}
    >
      {children}
    </Box>
  );
};

export default FilterBar;
